import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { MainLayout } from 'register-partners-js/react/components/layouts/main';
import { ErrorInfo } from 'register-partners-js/utils/error-info';

export default class RegistrationPricePlansOverviewsRoute extends Route {
  mainLayout = MainLayout;

  @service segment;
  @service intl;
  @service router;
  @service pricingService;
  @service sentry;

  queryParams = {
    recurrence: {
      refreshModel: false,
    },
    lineup: {
      refreshModel: false,
    },
  };

  async model(params, transition) {
    let registration = this.modelFor('registration');
    let organization = await registration.get('organization');

    let isPageReload = !transition.from;
    let isComingFromPricingStep = transition.from?.name === 'registration.price-plans';
    let lineup = this.getLineup(params, isPageReload, isComingFromPricingStep);

    return {
      organization,
      lineup,
      registration,
    };
  }

  setupController(controller, model, transition) {
    super.setupController(...arguments);

    controller.lineup = model.lineup;
    controller.getPricePlansTask
      .perform({
        legalCountry: model.organization.get('legalCountry'),
        partnerName: model.registration.partnerName?.toLowerCase(),
      })
      .catch(error => {
        if (ErrorInfo.for(error).shouldSendToSentry) {
          this.sentry.captureException(error);
        }
        this.send('error', new Error(error), transition);
        transition?.abort();
      });
  }

  activate() {
    this.intl.onLocaleChanged(this.refresh, this);
  }

  redirect({ organization }, transition) {
    if (
      (!transition.from || transition.from?.name !== 'registration.order-summary') &&
      organization.get('originalPricePlanCode')
    ) {
      this.router.replaceWith('registration.order-summary');
    }
  }

  getLineup({ lineup }, isPageReload, isComingFromPricingStep) {
    if (lineup && (isPageReload || isComingFromPricingStep)) {
      return lineup;
    }

    return 'solo';
  }
}
